import BigNumber from 'bignumber.js'

/** same as Array.find(), but in reverse order */
// eslint-disable-next-line no-unused-vars
export const findLast = <T>(arr: T[], criteria: (item: T) => boolean) => {
    for (let i = arr.length - 1; i >= 0; i--) {
        if (criteria(arr[i])) return arr[i]
    }
}

export async function loadApr() {
    const lidoApr = await fetch('https://eth-api.lido.fi/v1/protocol/steth/apr/sma')
        .then((res) => res.json())
        .then((obj: any) => parseFloat(obj.data.smaApr))

    const baseUrl = 'https://ddektitdlncgg.cloudfront.net/myswapapi'
    const [tvl, volume] = await Promise.all([fetch(`${baseUrl}/pool/${7}/tvl`).then((res) => res.json()), fetch(`${baseUrl}/pool/${7}/volume`).then((res) => res.json())])

    const last_tvl_entry = tvl.data[tvl.data.length - 1]
    const pool_tvl = new BigNumber(last_tvl_entry.token_a_tvl_usd ?? 0).plus(last_tvl_entry.token_b_tvl_usd ?? 0)

    let pool_volume_7d = new BigNumber(0)
    const most_recent_volume_time = volume.data[volume.data.length - 1].timestamp
    const volume_time_7d_ago = most_recent_volume_time - 7 * 24 * 60 * 60
    for (const daily_volume_data of volume.data) {
        const { timestamp, volume_usd } = daily_volume_data
        const is_within_7d = timestamp >= volume_time_7d_ago

        let pool_daily_volume = new BigNumber(0)
        const daily_volume_by_token = Object.entries(volume_usd)

        // for each token
        // eslint-disable-next-line no-unused-vars
        daily_volume_by_token.forEach(([_, token_volume_obj]) => {
            const dollar_value = new BigNumber((token_volume_obj as any).usd)
            if (!dollar_value.isZero()) {
                if (is_within_7d) {
                    // add day to pool's daily volume,
                    pool_daily_volume = pool_daily_volume.plus(dollar_value)
                }
            }
        })

        if (is_within_7d) {
            // add this day's volume to the pool's weekly volume
            pool_volume_7d = pool_volume_7d.plus(pool_daily_volume)
        }
    }

    const lidoDivided = new BigNumber(lidoApr).dividedBy(2).dividedBy(100)
    const lpYield = pool_volume_7d
        .multipliedBy(365 / 7)
        .multipliedBy(0.003)
        .div(pool_tvl)

    const totalYield = lpYield.plus(1).multipliedBy(lidoDivided.plus(1)).minus(1).multipliedBy(100)

    return totalYield.toFixed(0)
}

export function getStorageWallet() {
    return window.localStorage.getItem('wallet_address') || undefined
}

export const monthsAgo = (date: Date): number => {
    const currentDate = new Date()
    const months = (currentDate.getFullYear() - date.getFullYear()) * 12 + currentDate.getMonth() - date.getMonth()

    return months + 1 // Add 1 to include the current month
}

export function getRangeForFee(useFee: number) {
    let newRanges = [0.5, 1, 1.5, 2]
    if (useFee === 1) {
        newRanges = [5, 10, 20, 30]
    } else if (useFee >= 0.3) {
        newRanges = [2.5, 5, 10, 20]
    } else if (useFee > 0.01) {
        newRanges = [0.5, 1.5, 3, 5]
    } else {
        newRanges = [0.1, 0.3, 0.5, 0.7]
    }

    return newRanges
}
